export const SAVE_RECOVER_ORDER = 'SAVE_RECOVER_ORDER';
export const CLEAR_RECOVER_ORDER = 'CLEAR_RECOVER_ORDER';

// Reducer
export default function recoverOrderReducer(state = {}, action) {
  const { type, payload } = action;
  switch (type) {
    case SAVE_RECOVER_ORDER:
      return {
        ...state,
        ...payload,
      };
    case CLEAR_RECOVER_ORDER: {
      const newState = Object.assign({}, state);
      delete newState[payload];
      return newState;
    }
    default:
      return state;
  }
}

export function saveRecoverOrder(payload) {
  return { type: SAVE_RECOVER_ORDER, payload };
}

export function clearRecoverOrder(payload) {
  return { type: CLEAR_RECOVER_ORDER, payload };
}



// WEBPACK FOOTER //
// ./src/redux/modules/recoverOrder.js